import { render, staticRenderFns } from "./anonymous.vue?vue&type=template&id=23dcfde9"
import script from "./anonymous.vue?vue&type=script&lang=js"
export * from "./anonymous.vue?vue&type=script&lang=js"
import style0 from "./anonymous.vue?vue&type=style&index=0&id=23dcfde9&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports